import { INDICATIONS_TYPES } from "./constants";

const FIELD_BUILDERS = {
  medication: (ind, cfg) => ({
    ...cfg,
    inputType: "text",
    value: ind.publicMedication?.name || ind.medication?.name || "",
  }),
  diagnosis: (ind, cfg) => ({
    ...cfg,
    inputType: "text",
    value: ind.diagnosis?.name || ind.publicDiagnosis || "",
  }),
  publicDiagnosis: (ind, cfg) => ({ ...cfg, value: ind.publicDiagnosis || "" }),
  labs: (ind, cfg) => ({
    ...cfg,
    inputType: "text",
    value: Array.isArray(ind.labs)
      ? ind.labs.map((l) => l.description || l.code || "")
      : [],
  }),
  image: (ind, cfg) => {
    const images = Array.isArray(ind.images)
      ? ind.images
      : ind.image
      ? [ind.image]
      : [];
    return {
      ...cfg,
      inputType: "text",
      value: images.map((i) =>
        typeof i === "object" ? i.description || i.code || "" : i
      ),
    };
  },
  quantity: (ind, cfg) => ({ ...cfg, value: ind.quantity ?? "" }),
  generic: (ind, cfg) => ({ ...cfg, value: ind.generic ? "Sí" : "No" }),
  dosage: (ind, cfg) => ({ ...cfg, value: ind.dosage || ind.posology || "" }),
  posology: (ind, cfg) => ({ ...cfg, value: ind.posology || ind.dosage || "" }),
  isLongTerm: (ind, cfg) => ({
    ...cfg,
    value: ind.isLongTerm ? "Sí" : "No",
  }),
  replaceable: (ind, cfg) => ({
    ...cfg,
    value:
      ind.replaceable === "S"
        ? "Sí"
        : ind.replaceable === "N"
        ? "No"
        : ind.replaceable || "",
  }),
  description: (ind, cfg) => ({ ...cfg, value: ind.description || "" }),
  observation: (ind, cfg) => ({ ...cfg, value: ind.observation || "" }),
  observations: (ind, cfg) => ({ ...cfg, value: ind.observations || "" }),
  // Las evoluciones viejas guardaron el motivo elegido del desplegable en
  // `consultation`; lo mostramos como fallback para no perder ese dato.
  publicConsultation: (ind, cfg) => ({
    ...cfg,
    value: ind.publicConsultation || ind.consultation || "",
  }),
  patientDni: (ind, cfg) => ({ ...cfg, value: ind.patientDni || "" }),
  patientSocioNumber: (ind, cfg) => ({
    ...cfg,
    value: ind.patientSocioNumber || "",
  }),
  patientEmail: (ind, cfg) => ({ ...cfg, value: "" }),
  // No se persisten en el paciente ni en la indicación: se eligen de nuevo en cada receta.
  patientFinanciadorName: (ind, cfg) => ({ ...cfg, value: "" }),
  patientPlan: (ind, cfg) => ({ ...cfg, value: "" }),
  recetarioSolidario: (ind, cfg) => ({ ...cfg, value: false }),
};

export function mapBackendIndicationToFrontend(ind) {
  const typeConfig = INDICATIONS_TYPES.find((t) => t.type === ind.type);
  if (!typeConfig) return null;

  const defaultValues = {};
  for (const [key, config] of Object.entries(typeConfig.defaultValues)) {
    const builder = FIELD_BUILDERS[key];
    defaultValues[key] = builder
      ? builder(ind, config)
      : { ...config, value: ind[key] ?? config.value };
  }

  return {
    key: ind._id,
    _id: ind._id,
    type: ind.type,
    name: typeConfig.name,
    createdAt: ind.createdAt,
    defaultValues,
  };
}
